import { GatsbyImageData } from '@projectTypes/GatsbyImageData';
import { IGatsbyImageData } from 'gatsby-plugin-image';

export const imagePicker = (
	img: GatsbyImageData
): IGatsbyImageData | string => {
	return img.imageFile.extension !== 'svg'
		? img.imageFile.childImageSharp.gatsbyImageData
		: img.imageFile.publicURL;
};
